import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Outlet, useParams } from "react-router-dom";
import Crm_Toolbar from "../crm/components/Crm_Toolbar";
import { useCRMQuests } from "../crm/hooks/useCRMQuests";
import { Sidebar_ } from "../../components/Sidebar/Sidebar_";
import { Sidebar_Social } from "../../components/Sidebar/Sidebar_Social";
import { Sidebar_Tools } from "../../components/Sidebar/Sidebar_Tools";
import Sidebar_Quests from "../../components/Sidebar/Sidebar_Quests";
import { device } from "monica-alexandria";
import { CRMContext } from "../../context/CrmContext";



const LayoutWrap = styled.div`
  margin-left: 30rem;
  display: flex;
  align-items: flex-start;
  min-height: calc(100vh - 6rem);

  @media ${device.sm} {
    margin-left: 8.2rem;
  }
`;

const Content = styled.div`
  /*
  Previous version:
  padding-left: 8rem;
  */
  flex: 1;
  min-width: 0;
`;

export default function CRM_LAYOUT() {
  const { questId } = useParams();
  const value = useCRMQuests({ initialQuestId: questId });
  const [sidebar, setSidebar] = useState(() => {
    if (typeof window === "undefined") {
      return true;
    }

    return !window.matchMedia(device.sm.replace("@media ", "")).matches;
  });
  useEffect(() => {
    const media = window.matchMedia(device.sm.replace("@media ", ""));
    const update = () => setSidebar(!media.matches);
    media.addEventListener?.('change', update);
    return () => media.removeEventListener?.('change', update);
  }, []);


        
  return (
    <CRMContext.Provider value={value}>
      <LayoutWrap sidebar={sidebar}>
        {/* <Crm_Toolbar /> */}
        <Sidebar_ sidebar={sidebar} setSidebar={setSidebar} >
          {/* {/* <Sidebar_Social sidebar={sidebar} setSidebar={setSidebar} /> */}
          <Sidebar_Tools sidebar={sidebar} setSidebar={setSidebar} /> 
          <Sidebar_Quests sidebar={sidebar} setSidebar={setSidebar} />
        </Sidebar_>
        <Content>
          <Outlet />
        </Content>
      </LayoutWrap>
    </CRMContext.Provider>
  );
}
